import { b as y } from "./breakpoint-2bb21c87.mjs";
import { twMerge as E } from "tailwind-merge";
import K from "@fastify/deepmerge";
import { b as Y, e as q, g as Q } from "./blueprintTailwindTransformer-e300a306.mjs";
function w(e) {
  const t = {}, n = e.slots;
  return typeof n > "u" || Object.keys(n).forEach((r) => {
    const o = r;
    t[o] = n[o];
  }), t;
}
function m(e) {
  return typeof e != "object" || e === null ? !1 : Object.keys(e).some(
    (t) => y.includes(t)
  );
}
function C(e, t) {
  return Object.entries(e.variants).every(
    ([n, r]) => Object.entries(t).filter(
      ([o]) => n === o
    ).every(([, o]) => typeof o == "string" ? r === o : m(o) ? Object.keys(o).some(
      (f) => o[f] === r
    ) : !1)
  );
}
function S(e, t) {
  return (t == null ? void 0 : t.split(" ").filter((n) => n !== "").map(
    (n) => (e === "initial" ? "" : e + ":") + n
  ).join(" ")) ?? "";
}
function v(e, t, n, r) {
  Object.entries(n.variants).every(
    ([f, i]) => {
      const s = r[f];
      if (typeof s == "string")
        return i === s;
      if (m(s))
        return i === s[e];
    }
  ) && Object.keys(n.slots).forEach((f) => {
    const i = f;
    t[i] || (t[i] = /* @__PURE__ */ new Set()), t[i].add(n.slots[i]);
  });
}
function M(e) {
  return Object.values(e).some(
    (t) => m(t)
  );
}
function k(e, t, n) {
  if (typeof n > "u" || typeof e.compoundVariants > "u")
    return;
  const r = {
    initial: {},
    md: {},
    lg: {},
    xl: {}
  };
  y.forEach((o) => {
    e.compoundVariants !== void 0 && e.compoundVariants.forEach((f) => {
      C(
        f,
        n
      ) && (M(n) ? y.forEach((i) => {
        r[i] = r[i] ?? {}, v(
          i,
          r[i],
          f,
          n
        );
      }) : (r.initial = r.initial ?? {}, v(
        o,
        r.initial,
        f,
        n
      )));
    });
  }), y.forEach((o) => {
    Object.keys(r[o]).forEach((f) => {
      const i = f, c = r[o][i];
      c && (t[i] = [
        t[i],
        S(o, [...c].join(" "))
      ].join(" "));
    });
  });
}
function B(e) {
  return typeof e == "object" && e !== null;
}
function _(e, t, n) {
  const r = e.variants;
  typeof r > "u" || Object.keys(n).forEach((o) => {
    const f = r[o];
    if (typeof f > "u")
      return;
    const i = n[o];
    if (typeof i == "string") {
      const c = f[i];
      if (typeof c > "u")
        return;
      Object.keys(c).forEach((s) => {
        const u = s;
        t[u] = [
          t[u],
          c[u]
        ].join(" ");
      });
    } else
      B(i) && Object.keys(i).forEach((c) => {
        const s = f[i[c]];
        typeof s > "u" || Object.keys(s).forEach((u) => {
          const l = u;
          t[l] = [
            t[l],
            S(
              c,
              s[l]
            )
          ].join(" ");
        });
      });
  });
}
function N(e, t, n) {
  typeof n > "u" || _(e, t, n);
}
function a(e) {
  return Object.keys(e).sort().reduce((n, r) => (n[r] = e[r], n), {});
}
function x(e, t) {
  const n = {};
  if (!t && !e)
    return n;
  if (!t && e)
    return a(e);
  if (!e && t)
    return a(t);
  if (e && t) {
    for (const r in e) {
      const o = r;
      n[o] = e[o];
    }
    for (const r in t) {
      const o = r;
      n[o] = t[o];
    }
  }
  return a(n);
}
let T = E;
function A(e) {
  T = e;
}
function d() {
  return T;
}
function W(e) {
  const t = d();
  t !== void 0 && Object.keys(e).forEach((n) => {
    const r = n;
    e[r] = t(e[r]);
  });
}
function z(e, t) {
  const n = w(e), r = x(
    e.defaultVariants,
    t
  );
  return N(e, n, r), k(e, n, r), W(n), n;
}
function g(e) {
  const t = Object.getOwnPropertyNames(e);
  for (let n of t) {
    let r = e[n];
    r && typeof r == "object" && g(r);
  }
  return Object.freeze(e);
}
function b(e, t) {
  return g(t || e);
}
const I = K(), J = 200;
function p(e) {
  let t = b(e);
  const n = /* @__PURE__ */ new Map();
  let r = d();
  return {
    get: () => t,
    override: (s) => {
      t = b(t, s), n.clear();
    },
    clone: (s, u = {
      mergeWithClonedObject: !1
    }) => s === void 0 ? p(
      JSON.parse(JSON.stringify(t))
    ) : u.mergeWithClonedObject ? p(
      I(
        t,
        s
      )
    ) : p(
      s
    ),
    styles: (s) => {
      const u = d();
      u !== r && (n.clear(), r = u);
      const l = s === void 0 ? "" : JSON.stringify(
        s,
        (F, j) => j === void 0 ? " undefined" : j
      ), O = n.get(l);
      if (O !== void 0)
        return { ...O };
      const h = z(t, s);
      return n.size >= J && n.clear(), n.set(l, h), { ...h };
    }
  };
}
export {
  Y as blueprintTailwindTransformer,
  y as breakpoints,
  p as createBlueprint,
  g as deepFreeze,
  q as extractBlueprintClassesFromSource,
  Q as getBlueprintClasses,
  d as getBlueprintTwMerge,
  A as setBlueprintTwMerge
};
//# sourceMappingURL=index.mjs.map
